module.exports = __webpack_public_path__ + "static/icon.c6f4bb78.svg";